import { BIModel } from './BIModel';

export class UserFollowBIModel extends BIModel {

  static eventName = 'user_follow';

  #followedUserId;
  #action;
  #flow;
  #countrySeller;

  constructor(userId, followedUserId, action, flow, countrySeller) {
    super(UserFollowBIModel.eventName, userId);
    this.#followedUserId = followedUserId;
    this.#action = action;
    this.#flow = flow;
    this.#countrySeller = countrySeller;
  }

  static createFromDomainEvent(userId, userFollowEvent) {
    return new UserFollowBIModel(
        userId,
        userFollowEvent.followedUserId,
        userFollowEvent.action,
        userFollowEvent.flow,
        userFollowEvent.countrySeller
    );
  }

  get followedUserId() {
    return this.#followedUserId;
  }


  get action() {
    return this.#action;
  }

  get flow() {
    return this.#flow;
  }

  get countrySeller() {
    return this.#countrySeller;
  }

  get modelData() {
    return {
      followed_user_id: this.followedUserId,
      action: this.action,
      flow: this.flow,
      country_seller: this.countrySeller
    };
  }

}